import Spinner from "../../common/components/Spinner";
import I18n from "i18n-js";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { formatDateTime } from "../../common/utils/dateUtils";
import React from "react";
import PropTypes from "prop-types";

const triggers = ["focus", "hover", "click"];

TrackdechetsCompanyMemberStatusBadgeWithTooltip.propTypes = {
  isMember: PropTypes.bool,
  lastUpdatedAt: PropTypes.instanceOf(Date),
};

export function TrackdechetsCompanyMemberStatusBadgeWithTooltip({
  isMember,
  lastUpdatedAt = null,
}) {
  return (
    <OverlayTrigger
      trigger={triggers}
      placement="auto"
      delay={{ show: 10, hide: 150 }}
      overlay={
        <Tooltip style={{ position: "fixed" }}>
          {lastUpdatedAt ? (
            <small>
              {I18n.t(
                "trackdechets.sync_statuses_table.cell.badges.invalid.lastUpdatedAt",
                {
                  date: formatDateTime(lastUpdatedAt),
                },
              )}{" "}
            </small>
          ) : (
            <small>
              {I18n.t(
                "trackdechets.sync_statuses_table.cell.badges.unknown.title",
              )}
            </small>
          )}
        </Tooltip>
      }
    >
      <div>
        <CompanyMemberStatusIcon isMember={isMember} />
      </div>
    </OverlayTrigger>
  );
}

CompanyMemberStatusIcon.propTypes = {
  isMember: PropTypes.bool,
};

function CompanyMemberStatusIcon({ isMember }) {
  switch (isMember) {
    case null: {
      return (
        <div className={`text-info`}>
          <i className={`fa-solid fa-question`} />
        </div>
      );
    }
    case true:
      return (
        <div className={`text-success`}>
          <i className={`fa-solid fa-check`} />
        </div>
      );
    case false:
      return (
        <div className={`text-danger`}>
          <i className={`fa-solid fa-times`} />
        </div>
      );
    default:
      return null;
  }
}

CompanyMemberStatusCell.propTypes = {
  isMember: PropTypes.bool,
  loading: PropTypes.bool,
  lastUpdatedAt: PropTypes.instanceOf(Date),
  error: PropTypes.bool,
  refresh: PropTypes.func.isRequired,
  userHasLinkedAccount: PropTypes.bool,
};

export function CompanyMemberStatusCell({
  isMember = null,
  lastUpdatedAt = null,
  error = false,
  loading = false,
  refresh,
  userHasLinkedAccount = true,
}) {
  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <TrackdechetsCompanyMemberStatusBadgeWithTooltip
        isMember={false}
        lastUpdatedAt={lastUpdatedAt}
      />
    );
  }

  if (!userHasLinkedAccount) {
    return (
      <div className="trackdechets-sync-status">
        <TrackdechetsCompanyMemberStatusBadgeWithTooltip
          isMember={isMember}
          lastUpdatedAt={lastUpdatedAt}
        />
        <OverlayTrigger
          trigger={["focus", "hover"]}
          placement="top"
          delay={{ show: 10, hide: 150 }}
          overlay={
            <Tooltip style={{ position: "fixed" }}>
              Vous n&apos;avez pas associé de compte Trackdéchets. Cette information
              ne peut pas être récupérée ou actualisée.
            </Tooltip>
          }
        >
          <span
            style={{
              display: "inline-block",
              cursor: "not-allowed",
              padding: "0 5px",
            }}
          >
            <i
              className="fa-solid fa-exclamation-triangle text-warning"
              style={{ fontSize: "1em" }}
            />
          </span>
        </OverlayTrigger>
      </div>
    );
  }

  return (
    <div className="trackdechets-sync-status">
      <TrackdechetsCompanyMemberStatusBadgeWithTooltip
        isMember={isMember}
        lastUpdatedAt={lastUpdatedAt}
      />
      <button
        className="btn btn-xs refresh"
        title="Rafraîchir"
        onClick={refresh}
      >
        <i className="fa-solid fa-refresh" />
      </button>
    </div>
  );
}
